import { DRAWING_TOOL } from "@plugins/drawing/drawing.constants";

export const CANVAS_TOOLS = [
  { name: DRAWING_TOOL.PEN, size: 5 },
  { name: DRAWING_TOOL.HIGHLIGHTER, size: 20 },
  { name: DRAWING_TOOL.ERASER, size: 20 },
  { name: DRAWING_TOOL.IMAGE, size: 0 },
  { name: DRAWING_TOOL.TEXT_BOX, size: 0 },
];

export const CANVAS_COLORS = [
  { name: "Red", value: "#C14149" },
  { name: "Orange", value: "#F3812F" },
  { name: "Yellow", value: "#FBBC04" },
  { name: "Green", value: "#67B717" },
  { name: "Blue", value: "#20CDD8" },
  { name: "Purple", value: "#A674DF" },
  { name: "White", value: "#FFFFFF" },
  { name: "Black", value: "#0B233F" },
];

export const PEN_HIGHLIGHTER_SIZE = [2, 5, 10, 20, 30];
export const ERASER_SIZE = [5, 10, 20, 30, 40];

export const CANVAS_STROKE_SETTINGS = {
  selectable: true,
  erasable: true,
  hasControls: true,
};

export const CANVAS_SETTINGS = {
  erasable: true,
  defaultTool: DRAWING_TOOL.PEN,
  defaultColorForTeacher: "#C14149",
  defaultColorForStudent: "#0B233F",
  defaultHighlighterColor: "#FBBC04",
  backgroundColor: "#E7E9EC",
  drawingArea: "#FFFFFF",
  width: 455,
  height: 455,
  resizeDebouncePeriod: 500,
};

export const CANVAS_TEXT_SETTINGS = {
  placeholderText: "Type here",
  textBox: {
    fontSize: 30,
    fontFamily: "Noto Sans",
    width: 120,
    selectable: true,
    lockRotation: true,
    hasRotatingPoint: false,
    backgroundColor: "transparent",
  },
};

// NOTE: fileType only supports "jpeg" or "png"
const fileType = "png";
export const CANVAS_FILE_SETTINGS = {
  defaultFileName: "drawing." + fileType,
  defaultFileType: "image/" + fileType,
  defaultFileExtension: "." + fileType,
  imageScaleMultiplier: 1,
};
